import React from 'react'
import AdminDash from '../Components/AdminComponents/AdminDash/AdminDash'
import AdminHomeBoxes from '../Components/AdminComponents/AdminHomeBoxes/AdminHomeBoxes'

function AdminHome() {
  return (
    
    <AdminDash>
        <AdminHomeBoxes/>
    </AdminDash>
  )
}

export default AdminHome